import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AzureTableCopySource } from 'app/model/pipeline/copysource/azure-table.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureTableCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        azureTableSourceQuery: '*',
        azureTableSourceIgnoreTableNotFound: '*'
    }
})
export class AzureTableCopySourceAdapter extends CopySourceAdapter<AzureTableCopySource, Model.AzureTableSource> {
    protected override async _toResource(copySource: AzureTableCopySource): Promise<Model.AzureTableSource> {
        const result: Model.AzureTableSource = this.getCommonCopySourceProperties(copySource, 'AzureTableSource');
        if (copySource.mode === 'query') {
            result.azureTableSourceQuery = ValueAdapter.toResource(copySource, AzureTableCopySource.READER_QUERY);
        }
        const ignoreTableNotFoundValue = ValueAdapter.toResource(
            copySource,
            AzureTableCopySource.IGNORE_TABLE_NOT_FOUND
        );
        if (ignoreTableNotFoundValue != null) {
            result.azureTableSourceIgnoreTableNotFound = ignoreTableNotFoundValue;
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.AzureTableSource,
        copyActivity: CopyActivity
    ): Promise<AzureTableCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AzureTableCopySource.MODEL,
            resource,
            copyActivity
        ) as AzureTableCopySource;
        if (resource.azureTableSourceQuery) {
            ValueAdapter.toModel(result, AzureTableCopySource.READER_QUERY, resource.azureTableSourceQuery);
            result.mode = 'query';
        }
        if (resource.azureTableSourceIgnoreTableNotFound != null) {
            ValueAdapter.toModel(
                result,
                AzureTableCopySource.IGNORE_TABLE_NOT_FOUND,
                resource.azureTableSourceIgnoreTableNotFound
            );
        }
        return result;
    }
}
